import PriceSection from './price';
import { i18N } from "../../../helper";
class CONSTANTS {
    static template() {
        return `<label class="input__checkbox">
			<input type="checkbox" name="based_on_original" class="input__checkbox__input" value="1">
			<span class="input__checkbox__label">${i18N().set_sale_based_on_regular}</span>
		</label>`;
    }
}
export default class PriceSaleSection extends PriceSection {
    constructor() {
        super();
        this.checkTypeElementState();
        this.getTypeElement().insertAdjacentHTML('beforeend', `<option value="clear">${i18N().clear_sale_price}</option>`);
    }
    setElement() {
        super.setElement();
        this.getElement().querySelector('.input__divider').insertAdjacentHTML('afterend', CONSTANTS.template());
    }
    checkTypeElementState() {
        const type_element = this.getTypeElement();
        if (this.isBasedOnOriginal()) {
            type_element.querySelector('option[value=flat]').setAttribute('disabled', 'disabled');
            type_element.querySelector('option[value=increase_percentage]').setAttribute('disabled', 'disabled');
            type_element.value = type_element.querySelector('option:not([disabled])').value;
            type_element.dispatchEvent(new Event('change'));
        }
        else {
            type_element.querySelector('option[value=flat]').removeAttribute('disabled');
            type_element.querySelector('option[value=increase_percentage]').removeAttribute('disabled');
        }
    }
    initState() {
        if ('clear' === this.getTypeElement().value) {
            return this.togglePriceInputSection(false);
        }
        this.togglePriceInputSection();
        super.initState();
    }
    togglePriceInputSection(show = true) {
        show
            ? this.getPriceElement().parentElement.style.visibility = 'visible'
            : this.getPriceElement().parentElement.style.visibility = 'hidden';
    }
    attachEvents() {
        super.attachEvents();
        this.checkTypeElementState();
        const checkbox = this.getBasedOnOriginalElement();
        if (checkbox) {
            checkbox.addEventListener('change', () => {
                this.checkTypeElementState();
            });
        }
    }
    getBasedOnOriginalElement() {
        return this.getElement().querySelector('[name=based_on_original]');
    }
    isBasedOnOriginal() {
        return this.getBasedOnOriginalElement().checked;
    }
    getValue() {
        let value = super.getValue();
        value.based_on_regular = this.isBasedOnOriginal();
        return value;
    }
}
